"use strict";
var $dyn;
(function ($dyn) {
    function showConnectionErrorDialog(dialogOptions) {
        var dialog = new $dyn.controls.ConnectionErrorDialog(dialogOptions);
        var options = {
            context: dialog,
            role: "Dialog",
            templateId: "ConnectionErrorDialog",
        };
        $dyn.shell.createForm(options);
        $dyn.clientInError(true);
        $dyn.shell.dialog(options);
    }
    $dyn.showConnectionErrorDialog = showConnectionErrorDialog;
    var controls;
    (function (controls) {
        var ConnectionErrorDialog = /** @class */ (function () {
            function ConnectionErrorDialog(dialogOptions) {
                var _this = this;
                this.dialogOptions = dialogOptions;
                this.BrowserInteractionTimestamp = $dyn.format("{0} {1}", $dyn.label("MessageBox_BrowserInteractionTimestamp"), $dyn.browserActivity.BrowserInteractionActivity.UtcTimestamp);
                this.BrowserSessionActivityId = $dyn.format("{0} {1}", $dyn.label("MessageBox_BrowserSessionActivityId"), $dyn.browserActivity.BrowserSessionActivity.Id);
                this.buildInformation = $dyn.util.getBuildString();
                this.showTelemetryData = $dyn.observable(false);
                this.imageName = dialogOptions.ImageName;
                this.altText = dialogOptions.Tooltip;
                this.TitleText = dialogOptions.Text;
                this.retryButtonText = dialogOptions.RetryText;
                this.groupFrameOption = $dyn.observable(0);
                this.groupLabel = $dyn.computed(function () { return $dyn.value(_this.groupFrameOption) ? $dyn.label("Dialog_HideDiagnostic") : $dyn.label("Dialog_ShowDiagnostic"); });
                this.ActiveControl = "Retry";
                // this is required as when function like retry is called from Button click of connection error form
                // this context is changed to that button, hence we are saving the current this context to use in functions
                var self = this;
                // tslint:disable-next-line:only-arrow-functions
                this.retry = function () {
                    $dyn.clientInError(false);
                    $dyn.shell.dialogBack();
                    if (self.dialogOptions && typeof self.dialogOptions.Callback === "function") {
                        self.dialogOptions.Callback.apply(null, arguments);
                    }
                };
            }
            return ConnectionErrorDialog;
        }());
        controls.ConnectionErrorDialog = ConnectionErrorDialog;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ConnectionErrorDialog.js.map
